import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AcceptIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#56b40b' : this.getColor()
    return [
      <g>
        <path fill={color} fillRule='evenodd' clipRule='evenodd' d="M6.978,13.971 C3.117,13.971 -0.012,10.842 -0.012,6.981 C-0.012,3.120 3.117,-0.009 6.978,-0.009 C10.839,-0.009 13.968,3.120 13.968,6.981 C13.968,10.842 10.839,13.971 6.978,13.971 ZM5.051,2.000 L3.674,6.024 L5.539,6.024 L6.020,2.000 L5.051,2.000 ZM8.957,2.011 L7.899,2.011 L8.355,6.024 L10.315,6.024 L8.957,2.011 ZM10.656,7.030 L10.647,7.006 L8.466,7.006 L8.469,7.030 L5.419,7.030 L5.421,7.006 L3.339,7.006 L3.330,7.030 L1.982,7.030 L1.982,8.032 L2.988,8.032 L2.976,8.068 L2.957,10.957 L4.949,10.957 L5.299,8.032 L8.583,8.032 L8.915,10.957 L11.025,10.957 L11.007,8.068 L10.995,8.032 L11.964,8.032 L11.964,7.030 L10.656,7.030 Z" />
      </g>
    ]
  }
  getViewBox = () => '0 0 16 16'
}
